import React, { Component } from "react";
import { HashRouter, Route, Switch } from "react-router-dom";
import "./scss/style.scss";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Connector } from "mqtt-react-hooks";

const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_KEY}`);

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const TheLayout = React.lazy(() => import("./containers/TheLayout"));

// Pages
const Confirmation = React.lazy(() =>
  import("./views/pages/purchase/Confirmation")
);
const Login = React.lazy(() => import("./views/pages/login/Login.js"));
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));
const PasswordReset = React.lazy(() =>
  import("./views/pages/password-reset/PasswordReset.js")
);
const Payment = React.lazy(() => import("./views/pages/purchase/Payment"));
const Purchase = React.lazy(() => import("./views/pages/purchase/Purchase"));
const Register = React.lazy(() => import("./views/pages/register/Register"));
const TermsAndConditions = React.lazy(() =>
  import("./views/pages/terms-and-conditions/TermsAndConditions")
);

const options = {
    // Clean session
    clean: true,
    connectTimeout: 4000,
    // Auth
    clientId: 'ajttracking',
    username: 'G0GsFXnmAGQ1WF75CCCqIT5LfcbtKh0e6uuBhHLFbsuXVpQlRiAn0tW5vYm33a5Z',
    password: '',
  }

class App extends Component {
  render() {
    return (
      <Connector brokerUrl="wss://mqtt.flespi.io:443" options={options}>
        <Elements stripe={stripePromise}>
          <HashRouter>
            <React.Suspense fallback={loading}>
              <Switch>
                <Route
                  exact
                  path="/login"
                  name="Login Page"
                  render={(props) => <Login {...props} />}
                />
                <Route
                  exact
                  path="/register"
                  name="Register Page"
                  render={(props) => <Register {...props} />}
                />
                <Route
                  exact
                  path="/password-reset"
                  name="Password Reset Page"
                  render={(props) => <PasswordReset {...props} />}
                />
                <Route
                  exact
                  path="/purchase"
                  name="Purchase Page"
                  render={(props) => <Purchase {...props} />}
                />
                <Route
                  exact
                  path="/purchase/payment"
                  name="Purchase Payment Page"
                  render={(props) => <Payment {...props} />}
                />
                <Route
                  exact
                  path="/purchase/payment/confirmation"
                  name="Purchase Confirmation Page"
                  render={(props) => <Confirmation {...props} />}
                />
                <Route
                  exact
                  path="/terms-and-conditions"
                  name="Terms and Conditions"
                  render={(props) => <TermsAndConditions {...props} />}
                />
                <Route
                  exact
                  path="/404"
                  name="Page 404"
                  render={(props) => <Page404 {...props} />}
                />
                <Route
                  exact
                  path="/500"
                  name="Page 500"
                  render={(props) => <Page500 {...props} />}
                />
                <Route
                  path="/"
                  name="Home"
                  render={(props) => <TheLayout {...props} />}
                />
              </Switch>
            </React.Suspense>
          </HashRouter>
        </Elements>
      </Connector>
    );
  }
}

export default App;
